const formatter = new Intl.NumberFormat('ru-RU', {
  style: 'decimal',
  useGrouping: true,
  maximumFractionDigits: 2,
});

export const price = (value: number | string) => formatter
  .format(Number(value))
  .replace(',', '.');
